// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__cUwCu","main":"MainLayout_main__69Ait"};